import UploadFileSpec from "@/models/specs/UploadFileSpec";
import { savePhotoEntry } from "@/api/photo-api";

export default async function uploadPhoto(
  projectId: string,
  folderId: string,
  file: File
) {
  const spec = new UploadFileSpec();
  if (!spec.isSatisfied(file)) {
    alert(spec.errors);
    return;
  }
  const data = new FormData();
  data.append("projectId", projectId);
  data.append("parentFolderId", folderId);
  data.append("kind", "file");
  data.append("image", file);
  await savePhotoEntry(data);
}
